"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = require("react");

var _Form = require("../Form");

var _reactFinalForm = require("react-final-form");

var _TextField = require("../../TextField");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["name", "helperText", "readOnly", "disabled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var FormTextField = function FormTextField(_ref) {
  var name = _ref.name,
      helperText = _ref.helperText,
      readOnly = _ref.readOnly,
      disabled = _ref.disabled,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var formProps = (0, _Form.useFormProps)(); // Custom callback will be used in dirty/pristine form state calculations.

  var isEqual = (0, _react.useCallback)(function (a, b) {
    // Handle `nullish` values
    var A = a !== null && a !== void 0 ? a : "";
    var B = b !== null && b !== void 0 ? b : "";
    return A === B;
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalForm.Field, {
    isEqual: isEqual,
    name: name,
    children: function children(_ref2) {
      var input = _ref2.input,
          meta = _ref2.meta;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.TextField, _objectSpread(_objectSpread(_objectSpread({
        fullWidth: false,
        margin: "normal"
      }, input), rest), {}, {
        disabled: disabled !== null && disabled !== void 0 ? disabled : formProps.disabled,
        error: meta.submitError && !meta.dirtySinceLastSubmit || !!rest.error,
        helperText: meta.touched && meta.submitError && !meta.dirtySinceLastSubmit ? meta.submitError : helperText,
        readOnly: readOnly !== null && readOnly !== void 0 ? readOnly : formProps.readOnly
      }));
    }
  });
};

var _default = FormTextField;
exports.default = _default;